import React from 'react'
import {Route, IndexRoute} from 'react-router'

import OrdersInsightView from 'views/OrdersInsightView'
import OrdersInsightViewMenu from 'views/OrdersInsightView/menu'
import OrdersInsightFindView from 'views/OrdersInsightView/OrdersInsightFindView'

export default trackRoute => {
  return (
    <Route path='attribution-explorer' title='Attribution'>
      <Route
        path='findById'
        title='Search Conversions by ID'
        components={{main: OrdersInsightFindView, menu: OrdersInsightViewMenu}}
        onEnter={trackRoute('orders-find-by-id')}
      />
      <IndexRoute
        title='Attribution Explorer'
        components={{main: OrdersInsightView, menu: OrdersInsightViewMenu}}
        onEnter={trackRoute('attribution-explorer')}
      />
    </Route>
  )
}



// WEBPACK FOOTER //
// ./client/routes/ordersExplorer.js